<template>
  <header 
    class="px-[38px] lg:px-0 py-[20px] fixed z-10 top-0 left-0 right-0 w-full font-boliviaSemiextended"
   :class="[scrollPosition >= 50 ? 'bg-ares_background' : '', {'background-open-state': active}, 'transition']"
   >
    <div class="relative flex justify-between max-w-[1024px] mx-auto ">
      <img @click="active =! active" class="hidden lg:block cursor-pointer h-[15px] lg:h-[30px]" :class="{'!opacity-0': active}" src="/assets/svgs/Burger.svg" alt="Menu Open Icon" />
      <img @click="active =! active" class="-ml-[8px] -mt-[7px] lg:hidden cursor-pointer w-[61px] h-[33px]" :class="{'!opacity-0': active}" src="/assets/svgs/Burger_mobile.svg " alt="Menu Open Icon" />

      <a @click="active =! active"  class="absolute left-0 top-0  h-[15px] lg:h-[27px] flex cursor-pointer block" :class="{'hidden': !active}">

        <svg class="cursor-pointer mr-2 lg:mr-3 w-[30px]" style="fill:#ffffff" id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
          <defs>

          </defs>
          <polygon class="cls-1" points="25.91 3.43 24.5 2.02 14.25 12.27 3.99 2.02 2.58 3.43 12.83 13.69 2.58 23.94 3.99 25.35 14.25 15.1 24.5 25.35 25.91 23.94 15.66 13.69 25.91 3.43"/>
        </svg>
        <div class="font-SuisseIntlMonoRegular">Close</div>
      </a>

      <div class="space-x-4 lg:space-x-2" id="submenu">
        <slot></slot>
      </div>
    </div>
    <div class="header_sub text-20 lg:text-[34px] leading-[25px] lg:leading-[38px] tracking-[0.8px] lg:tracking-lg flex flex-col pt-[60px] lg:pt-[90px] pb-[25px]  max-w-[1024px] mx-auto " :class="{'hidden':!active}">
      <slot name="sub"></slot>
    </div>
  </header>


</template>

<script>

import _ from 'lodash';

export default {
  name: 'Navigation',
  data() {
    return {
      active: false,
      scrollPosition: 0,
      lastScrollTop: 0,
      scrollDirection: null
    };
  },
  mounted() {
    window.addEventListener('scroll', _.throttle(this.updateScroll, 100));
    window.addEventListener('scroll', _.throttle(this.setScrollPosition, 100));

    //close menu if click event outside of header
    document.getElementsByTagName('header')[0].addEventListener('click', (evt) => {
      evt.stopPropagation(); //if click event is inside of header, we don't want to close the menu
    })
    document.getElementsByTagName('html')[0].addEventListener('click', (evt) => {
      this.active = false;
    })

    this.emitter.on('close-gallery', (evt) => {
      this.active = false;
    })
  },
  unmounted() {

  },
  computed: {
    shrink() {
      return this.scrollPosition >= 50  ? '!h-[80px] lg:!h-[70px]' : '';
    }
  },
  methods: {
    open(){
      this.active = true;
    },
    openGallery(){
      this.emitter.emit("open-gallery");
    },
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    setScrollPosition(){


      let st = window.scrollY || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      if (st > this.lastScrollTop){
        this.scrollDirection = "down";
      } else {
        this.scrollDirection = "up";
      }
      this.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }
  },
};
</script>

<style>

  header, #logo {
    transition: height 350ms cubic-bezier(0.33, 1, 0.68, 1);
  }



</style>
